import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button, Heading, Input, Spinner } from '@flixbus/honeycomb-react';

import CrewMemberAutoCompleteSingleV2 from 'common/CrewMemberAutocompleteSingleV2';

import styles from './styles.module.css';

const defaultFormValues = {
	departureDate: '',
	departureTime: '',
	arrivalDate: '',
	arrivalTime: '',
	crewMember: null,
};

const PopUpEditAssignment = ({
	loading = false,
	onSubmit = () => {},
	defaultValues = defaultFormValues,
}) => {
	const { control, handleSubmit } = useForm({
		mode: 'onChange',
		defaultValues,
	});

	if (loading) {
		return <Spinner />;
	}

	return (
		<form
			className={styles.form}
			id="edit-assignment-form"
			aria-label="Edit assignment"
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className={styles.headerRow}>
				<div className={styles.sectionWide}>
					<Heading flushSpace Elem="h5" size={3}>
						Actual departure
					</Heading>
				</div>

				<div className={styles.sectionWide}>
					<Heading flushSpace Elem="h5" size={3}>
						Actual arrival
					</Heading>
				</div>

				<div className={styles.sectionMedium}>
					<Heading flushSpace Elem="h5" size={3}>
						Assignee
					</Heading>
				</div>

				<div className={styles.submit} />
			</div>

			<div className={styles.controlsRow}>
				<div className={styles.sectionWide}>
					<div className={styles.fieldsRow}>
						<div className={styles.dateField}>
							<Controller
								name="departureDate"
								control={control}
								rules={{ required: true }}
								render={({ field: { ref: _ref, ...field } }) => (
									<Input id="departureDate" label="Date" type="date" {...field} />
								)}
							/>
						</div>

						<div className={styles.timeField}>
							<Controller
								name="departureTime"
								control={control}
								rules={{ required: true }}
								render={({ field: { ref: _ref, ...field } }) => (
									<Input id="departureTime" label="Time" type="time" {...field} />
								)}
							/>
						</div>
					</div>
				</div>

				<div className={styles.sectionWide}>
					<div className={styles.fieldsRow}>
						<div className={styles.dateField}>
							<Controller
								name="arrivalDate"
								control={control}
								rules={{ required: true }}
								render={({ field: { ref: _ref, ...field } }) => (
									<Input id="arrivalDate" label="Date" type="date" {...field} />
								)}
							/>
						</div>

						<div className={styles.timeField}>
							<Controller
								name="arrivalTime"
								control={control}
								rules={{ required: true }}
								render={({ field: { ref: _ref, ...field } }) => (
									<Input id="arrivalTime" label="Time" type="time" {...field} />
								)}
							/>
						</div>
					</div>
				</div>

				<div className={styles.sectionMedium}>
					<div className={styles.assigneeField}>
						<Controller
							name="crewMember"
							control={control}
							render={({ field }) => (
								<CrewMemberAutoCompleteSingleV2
									label=""
									defaultValue={field.value}
									onSelection={field.onChange}
								/>
							)}
						/>
					</div>
				</div>

				<div className={styles.submit}>
					<Button appearance="primary" type="submit" form="edit-assignment-form">
						Update
					</Button>
				</div>
			</div>
		</form>
	);
};

export default PopUpEditAssignment;
